export interface CustomerAddress {
    id: number;
    lat: string;
    lon: string;
    address_type: string;
    address_line?: string;
    addressable_id?: number;
    in_delivery_area: boolean;
    in_special_zone?: boolean;
    formatted_landmark: string;
    formatted_locality: string;
    address_line_hash: any
    address_custom_name: string | null;
}

export enum AddressType {
    Home = 0 ,
    Work = 1,
    Others = 2
}
